import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fluid":""}},[_c('back-link-component',{attrs:{"to":{ name: 'TaskListAsList' },"label":_vm.$tt('feed.trajectories')}}),_c('div',{staticClass:"aid-bg-grey mt-4 text-center py-8 rounded-lg"},[_c('span',[_vm._v(_vm._s(_vm.$tt('customShowTaskDetailError')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }